export default {
  title: 'Info',
  sections: {
    work_schedule: 'Horaires : Commandes en ligne',
    delivery_schedule: 'Horaires de livraison',
    delivery_costs: 'Frais de livraison',
    website: 'Site web',
  },
  labels: {
    delivery_fees: 'Montant min. - {{threshold}}, Frais - {{fee}}',
  },
};
